var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgElementCryo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 314.09 314.09",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#9fd6e3;}.cls-2{fill:none;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Livello_2",
    "data-name": "Livello 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Livello_10",
    "data-name": "Livello 10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M157.22,11.84s-24.09,53.85-39,69.77c.31-.11,5.29-2,11.64-5.16,5.67,8,27.32,39.91,27.32,62.7,0-22.79,21.65-54.73,27.32-62.7,6.35,3.11,11.33,5,11.64,5.16C181.31,65.69,157.22,11.84,157.22,11.84Zm0,105.58a106.72,106.72,0,0,0-13.51-48.71c5.93-3.88,11.19-8.34,13.51-12.91,2.32,4.57,7.58,9,13.51,12.91A106.72,106.72,0,0,0,157.22,117.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M282.88,84.59S224.2,90.66,203,85.74c.25.21,4.42,3.56,10.28,7.5-4.06,8.89-20.9,43.61-40.63,55,19.73-11.4,58.22-8.62,68-7.69.49,7.05,1.3,12.34,1.36,12.66C248.29,132.38,282.88,84.59,282.88,84.59Zm-91.44,52.79a106.58,106.58,0,0,0,35.43-36c6.33,3.19,12.82,5.52,17.94,5.24-2.8,4.3-4,11.08-4.43,18.16C213.63,124.79,192.73,136.64,191.44,137.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M282.7,229.8S248.11,182,241.76,161.17c-.06.32-.87,5.61-1.35,12.66-9.74.93-48.22,3.71-68-7.69,19.74,11.4,36.57,46.11,40.64,55-5.87,3.94-10,7.29-10.29,7.5C224,223.73,282.7,229.8,282.7,229.8ZM191.27,177a106.79,106.79,0,0,0,48.94,12.65c.39,7.08,1.63,13.86,4.42,18.16-5.11-.28-11.61,2-17.93,5.24A106.77,106.77,0,0,0,191.27,177Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M156.87,302.24s24.09-53.85,39-69.77c-.31.11-5.29,2.05-11.64,5.16-5.67-8-27.32-39.91-27.32-62.7,0,22.79-21.65,54.73-27.32,62.7-6.35-3.11-11.33-5-11.64-5.16C132.78,248.39,156.87,302.24,156.87,302.24Zm0-105.58a106.72,106.72,0,0,0,13.51,48.71c-5.93,3.88-11.19,8.34-13.51,12.91-2.32-4.57-7.58-9-13.51-12.91A106.72,106.72,0,0,0,156.87,196.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M31.21,229.49s58.68-6.06,79.9-1.14c-.25-.22-4.42-3.56-10.29-7.5,4.07-8.9,20.91-43.62,40.64-55-19.73,11.39-58.22,8.61-68,7.69-.48-7.06-1.29-12.34-1.35-12.66C65.8,181.71,31.21,229.49,31.21,229.49Zm91.43-52.79a106.74,106.74,0,0,0-35.43,36.06c-6.32-3.2-12.81-5.52-17.93-5.25,2.8-4.29,4-11.08,4.42-18.15A106.73,106.73,0,0,0,122.64,176.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M31.38,84.29s34.59,47.79,41,68.63c.06-.33.87-5.61,1.35-12.66,9.73-.93,48.22-3.71,68,7.69-19.74-11.4-36.58-46.12-40.64-55,5.87-4,10-7.29,10.29-7.5C90.06,90.35,31.38,84.29,31.38,84.29Zm91.44,52.79a106.65,106.65,0,0,0-48.94-12.65c-.4-7.08-1.63-13.86-4.43-18.16,5.12.28,11.61-2,17.94-5.24A106.77,106.77,0,0,0,122.82,137.08Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 157.22,
    cy: 158.05,
    r: 5.65
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M153.85,138l2,17.62-14.29-10.5a15.63,15.63,0,0,1-6.37-12l-.45-12.36a1,1,0,0,1,1.44-.83l10.48,6.56A15.64,15.64,0,0,1,153.85,138Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M172.93,145.09l-14.29,10.5L160.58,138a15.68,15.68,0,0,1,7.25-11.55l10.48-6.56a.94.94,0,0,1,1.43.83l-.44,12.36A15.63,15.63,0,0,1,172.93,145.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M176.29,165.18l-16.23-7.13,16.23-7.13a15.62,15.62,0,0,1,13.62.51l10.92,5.79a.94.94,0,0,1,0,1.66l-10.92,5.79A15.65,15.65,0,0,1,176.29,165.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M160.58,178.13l-1.94-17.62L172.93,171a15.65,15.65,0,0,1,6.37,12.05l.44,12.35a.93.93,0,0,1-1.43.83l-10.48-6.56A15.68,15.68,0,0,1,160.58,178.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M141.51,171l14.29-10.49-2,17.62a15.63,15.63,0,0,1-7.24,11.54l-10.48,6.56a.94.94,0,0,1-1.44-.83l.45-12.35A15.65,15.65,0,0,1,141.51,171Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M138.15,150.92l16.23,7.13-16.23,7.13a15.65,15.65,0,0,1-13.62-.51l-10.92-5.79a.94.94,0,0,1,0-1.66l10.92-5.79A15.62,15.62,0,0,1,138.15,150.92Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    width: 314.09,
    height: 314.09
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgElementCryo);
export default __webpack_public_path__ + "static/media/Element_Cryo.3bdb562015df89a20e96599718419039.svg";
export { ForwardRef as ReactComponent };